module.exports = __webpack_public_path__ + "static/media/experience.46fb170d.svg";